import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TilesLayer } from '@tcc/treadstone';
import { BASE_FIELDVIEW_URL as BASE_URL } from '../../../constants/urls';
import { getFvpCacheBuster } from '../../../selectors/layerSelectors';
import { userSelector } from '../../../selectors/userSelectors';
import { getFieldBounds } from '../../../selectors/fieldSelectors';
import { logDmbError } from '../../../utils/error';
import { DMB_WEB_AG_VIZ } from '../../../constants/featureFlags';

export class HarvestAndPlantingMap extends Component {
  shouldComponentUpdate(nextProps) {
    return JSON.stringify(this.props) !== JSON.stringify(nextProps);
  }

  onTileError = (error) => {
    const tileUrl = error.target.options.url || error.target._url;
    logDmbError(`Tile image not loaded: ${tileUrl}`);
  };

  render() {
    const {
      agVizEnabled,
      agVizTileUrl,
      agVizVersion,
      cacheBuster,
      crop,
      dates,
      fieldBounds,
      fieldUuid,
      layer,
      user,
    } = this.props;
    const { endDate, startDate, year } = dates;

    // If Ag-Viz feature flag is enabled and we have an Ag-Viz tile URL, use it
    if (agVizEnabled && agVizTileUrl) {
      // Add version parameter for cache busting
      // Only add version parameter if we have a real version (not "UNKNOWN")
      const urlWithCacheBuster = agVizVersion && agVizVersion !== 'UNKNOWN'
        ? `${agVizTileUrl}&v=${agVizVersion}`
        : agVizTileUrl;
      return (
        <TilesLayer
          bounds={fieldBounds}
          onTileError={(error) => this.onTileError(error)}
          url={urlWithCacheBuster}
          zIndex={2}
          maxNativeZoom={20}
          maxZoom={20}
        />
      );
    }

    if (!cacheBuster) {
      return null;
    }

    // Original FV-Spatial tile URL construction
    const lastUrlPart = `{z}/{x}/{y}.png?startTime=${startDate}&endTime=${endDate}&cacheBuster=${cacheBuster}`;

    const firstPartUrl = `${BASE_URL}/tile/v3/${user.uuid}/${fieldUuid}/${year}/${crop}/${layer}/`

    const url = firstPartUrl + lastUrlPart;

    return (
      <TilesLayer
        bounds={fieldBounds}
        onTileError={(error) => this.onTileError(error)}
        url={url}
        zIndex={2}
        maxNativeZoom={20}
        maxZoom={20}
      />
    );
  }
}

HarvestAndPlantingMap.propTypes = {
  agVizEnabled: PropTypes.bool,
  agVizTileUrl: PropTypes.string,
  agVizVersion: PropTypes.string,
  cacheBuster: PropTypes.string,
  crop: PropTypes.string.isRequired,
  dates: PropTypes.object.isRequired,
  fieldBounds: PropTypes.array.isRequired,
  fieldUuid: PropTypes.string.isRequired,
  layer: PropTypes.string.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state, props) {
  const activeMapLayer = state.layers.activeMapLayers[props.index];
  const activeSeason = state.seasons.activeSeasons[props.index];
  
  const agVizEnabled = state.feature?.userConfigFeatures?.[DMB_WEB_AG_VIZ]?.value || false;
  
  // Get Ag-Viz tile URL and version if available
  const agVizTileUrl = activeSeason && activeMapLayer
    ? state.layers.list?.[activeSeason.id]?.[activeMapLayer.id]?.agVizTileUrl
    : null;
  
  const agVizVersion = activeSeason && activeMapLayer
    ? state.layers.list?.[activeSeason.id]?.[activeMapLayer.id]?.version
    : null;

  return {
    agVizEnabled,
    agVizTileUrl,
    agVizVersion,
    cacheBuster: getFvpCacheBuster(state, props),
    fieldBounds: getFieldBounds(state),
    fieldUuid: state.field.uuid.toUpperCase(),
    layer: activeMapLayer.id,
    user: userSelector(state)
  };
}

export default connect(mapStateToProps)(HarvestAndPlantingMap);
